import { PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export function Body({ children }: Props) {
  return <tbody>{children}</tbody>;
}
